import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  "fill-rule": "evenodd",
  d: "M7.774.157a9.5 9.5 0 1 1 0 18.687.792.792 0 1 1 .286-1.558q.7.13 1.44.13A7.917 7.917 0 1 0 8.06 1.715.792.792 0 0 1 7.774.157M5.83 1.56a.79.79 0 0 1-.289 1.082 7.96 7.96 0 0 0-2.679 2.54.792.792 0 1 1-1.326-.864A9.54 9.54 0 0 1 4.749 1.27a.79.79 0 0 1 1.082.29m8.171 4.99c.318.3.332.801.032 1.119L8.94 13.057a1.27 1.27 0 0 1-1.85 0L4.965 10.81a.792.792 0 0 1 1.151-1.088l1.899 2.009 4.867-5.15a.79.79 0 0 1 1.12-.031m-12.805.2c.426.099.69.524.592.95a8 8 0 0 0-.206 1.8c0 .62.071 1.223.206 1.8a.792.792 0 1 1-1.543.358A9.5 9.5 0 0 1 0 9.5c0-.742.085-1.464.246-2.158a.79.79 0 0 1 .95-.592m.57 6.837a.79.79 0 0 1 1.096.23 7.96 7.96 0 0 0 2.68 2.541.792.792 0 0 1-.794 1.37 9.55 9.55 0 0 1-3.212-3.046.79.79 0 0 1 .23-1.095",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }